<button
  role="button"
  tabindex="0"
  (keydown.enter)="toggle()"
  (click)="toggle()"
  class="cursor-pointer no-underline min-h-10 text-sm navigation-item__content menu">
  <div class="menu__left text-white">
    <lib-tess-icon icon="my-icons:status" size="var(--font-size-xxl)" />
  </div>

  <div class="menu__right">
    <div class="text-white opacity-70 flex items-center justify-between w-full pl-4 pr-2 py-0 dark:opacity-100">
      {{ theme.theme() === 'light' ? 'Dark' : 'Light' }} Theme
    </div>
  </div>
</button>
